import { render } from "./TournamentStartList.vue?vue&type=template&id=04800298&scoped=true"
import script from "./TournamentStartList.vue?vue&type=script&lang=js"
export * from "./TournamentStartList.vue?vue&type=script&lang=js"

import "./TournamentStartList.vue?vue&type=style&index=0&id=04800298&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04800298"]])

export default __exports__